jQuery(document).ready(function ($) {
    setInterval(function () {
        var tripAdvisorWidget = $('.mobileTripAdvisorWidget');
        var googleReviewsWidget = $('.mobileGoogleReviewsWidget');

        if (tripAdvisorWidget.is(':visible')) {
            tripAdvisorWidget.fadeOut(500, function () {
                googleReviewsWidget.fadeIn(500);
            });
        } else {
            googleReviewsWidget.fadeOut(500, function () {
                tripAdvisorWidget.fadeIn(500);
            });
        }
    }, 5000);
});